/*
 * Мультиканальная лента переписки брони (обновлённый макет чата). `--bubble-max` здесь НЕ
 * объявлен намеренно: его задаёт потребитель на своём контейнере (карточка брони — 86%, «Чаты» —
 * 78%). Объяви я его на корне, собственное значение побило бы унаследованное.
 */
.root {
  display: flex;
  flex: 1;
  flex-direction: column;
  /* Без этого лента не прокручивается, а распирает панель: у флекс-элемента `min-height: auto`. */
  min-height: 0;
}

/* Шапка треда — два ряда: идентификация + фильтр ленты. */
.head {
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--line);
}

.headTop {
  display: flex;
  align-items: center;
  gap: 11px;
}

/* Аватар гостя — инициалы (лента теперь про гостя и все его каналы, а не про один мессенджер). */
.avatar {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--sunk);
  color: var(--ink-2);
  font-size: 13px;
  font-weight: 600;
}

.headText {
  flex: 1;
  min-width: 0;
}

.headName {
  font-size: 13.5px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.headMeta {
  font-size: 11.5px;
  color: var(--ink-3);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.headSkeleton {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.headError {
  flex: 1;
  min-width: 0;
}

.profile {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  height: 28px;
  padding: 0 11px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--panel);
  color: var(--ink-2);
  font-size: 12px;
  font-weight: 550;
  text-decoration: none;
}
.profile:hover {
  border-color: var(--ink-4);
  color: var(--ink);
}

/*
 * «Открыть в мессенджере» — ссылка наружу (`<a target="_blank">`), 32×32, рамка `--line`, radius 8,
 * как кнопки шапки карточки. Свой класс, а не `IconButton` кита (тот 34×34, прозрачный, без рамки).
 */
.external {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--panel);
  color: var(--ink-3);
  cursor: pointer;
}
.external:hover {
  background: var(--sunk);
  color: var(--ink);
}

/* Фильтр ленты — сегмент-контрол (Всё / Диалог / События), как тумблеры макета. */
.filter {
  display: inline-flex;
  align-self: flex-start;
  gap: 2px;
  padding: 3px;
  border-radius: 8px;
  background: var(--sunk);
}

.filterTab {
  height: 26px;
  padding: 0 11px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--ink-3);
  font: inherit;
  font-size: 11.5px;
  font-weight: 500;
  cursor: pointer;
}

/*
 * Выбранную вкладку держат заливка и чернила — БЕЗ тени (макет `:5164`: `--panel` + `--ink`, и
 * больше ничего). ⚠️ Тень литеральным `oklch(…)` мимо палитры гейт контраста НЕ ВИДИТ по
 * построению — он меряет ТОКЕНЫ, — и раздел останется красным, пока кто-нибудь не посмотрит на
 * пиксель глазами. Тень вдобавок поднимает кнопку над её же контейнером, хотя она внутри него;
 * тот же лишний слой снят у сегментов в разделе «Квартиры».
 */
.filterTab[aria-selected='true'] {
  background: var(--panel);
  color: var(--ink);
  font-weight: 600;
}

/* Лента. */
.feed {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
  padding: 16px 15px 12px;
  overflow-y: auto;
}

.feedSkeleton {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.skeletonIn {
  align-self: flex-start;
}
.skeletonOut {
  align-self: flex-end;
}

.filterEmpty {
  align-self: center;
  margin: 14px 0;
  font-size: 12px;
  color: var(--ink-4);
}

/* Строка статуса треда («Ждёт ответа менеджера») — в конце ленты, так в макете. */
.statusNote {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 7px;
  padding: 2px 4px;
  font-size: 11px;
  color: var(--ink-3);
}

.statusDot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--st-pending);
}
